var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStanfordTax = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 65,
  height: 64,
  fill: "none",
  viewBox: "0 0 65 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#484F75",
  fillRule: "evenodd",
  stroke: "#484F75",
  strokeLinejoin: "round",
  strokeWidth: 0.25,
  d: "m30.6 20.283-7.872 4.56c-.509-.513-.763-1.368-1.218-1.954-1.148-1.477-2.856-2.52-4.743-2.678-2.392-.2-5.73.3-5.523 3.424.033.5.187.984.486 1.392 1.403 1.908 4.964 2.727 7.116 3.413 4.893 1.56 10.017 3.084 12.208 8.236.352.829.524 1.76.637 2.65.197 1.558.16 3.158-.178 4.696-1.235 5.618-5.83 8.323-11.095 9.382C12.416 55.012 3.05 51.722.125 43.616c.517-.481 1.305-.798 1.92-1.15q2.024-1.157 4.035-2.339c.467-.274 1.696-1.172 2.173-1.136.42.758.77 1.531 1.285 2.24 1.82 2.51 4.793 3.385 7.774 3.335 2.285-.04 5.4-.794 5.094-3.73-.13-1.25-1.1-2.07-2.137-2.623-2.023-1.083-4.273-1.512-6.436-2.218-4.797-1.567-10.141-3.545-11.55-9.025-.22-.86-.4-1.703-.428-2.598-.035-1.147-.034-2.292.2-3.42.24-1.175.659-2.279 1.23-3.329 4.337-7.96 16.149-8.382 22.738-3.203 1.442 1.136 2.649 2.544 3.622 4.093.335.53.818 1.154.955 1.77Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#536CF1",
  fillRule: "evenodd",
  stroke: "#536CF1",
  strokeLinejoin: "round",
  strokeWidth: 0.25,
  d: "M64.125 11.81v9.053H53.554v32.063h-9.399V20.862H33.584V11.81z",
  clipRule: "evenodd"
})));
export default SvgStanfordTax;